import React, { useCallback } from 'react';
import Card from 'components/inputs/Card';
import { Formik, Form } from 'formik';
import { Row, Col } from 'react-bootstrap';
import Button from 'components/inputs/Button';
import * as Yup from 'yup';
import { CHANGE_AVAILABILITY } from 'actions/chargerOcpp';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as _ from 'lodash';
import Select from 'components/inputs/Select';

const ChangeAvailabilitySchema = Yup.object().shape({
  connectorId: Yup.number().required('Connector Id is required'),
  type: Yup.string().required('Type is required!').max(100, 'Text limit should be less than 100 characters.'),
});

const ChangeAvailabilityForm = () => {
  const { chargerId } = useParams();
  const dispatch = useDispatch();
  const chargerDetailData = useSelector((state) => state.charger.chargerDetails);

  const getChangeAvailability = useCallback((data, resetForm) => {
    dispatch({
      type: CHANGE_AVAILABILITY,
      payload: { data },
      cb: (res) => {
        if (res) {
          if (_.get(res, 'status') === 200) {
            toast.success('Availability change successfully');
            resetForm();
          }
        }
      },
    });
  }, []);

  return (
    <React.Fragment>
      <div className="serverOperation-title-name">CHANGE AVAILABILITY CONFIGURATION</div>
      <div className="serverOperation-content-wrapper">
        <Card className="serverOperation-form-main">
          <div className="serverOperation-form__block">
            <Formik
              initialValues={{ connectorId: '', type: '' }}
              validationSchema={ChangeAvailabilitySchema}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                const formData = {
                  id: chargerId,
                  ...values,
                };
                getChangeAvailability(formData, resetForm);
                setSubmitting(false);
              }}
            >
              {({ values, errors, touched, handleSubmit, setFieldValue, isSubmitting }) => (
                <Form onSubmit={handleSubmit}>
                  <div className="serverOperation-form__inner">
                    <Row>
                      <Col>
                        <Select
                          isRequired
                          label="Connector Name"
                          placeholder="Select Connector Name"
                          options={_.map(_.get(chargerDetailData, 'plugs', []), (item) => {
                            return { label: `${item.name} - ${item.connector_id}`, value: item.connector_id };
                          })}
                          name="connectorId"
                          value={values.connectorId}
                          onChange={(val) => setFieldValue(`connectorId`, val)}
                          error={errors.connectorId && touched.connectorId ? errors.connectorId : null}
                        />
                      </Col>
                      <Col>
                        <Select
                          isRequired
                          label="Type"
                          placeholder="Select Type"
                          options={[
                            { label: 'Inoperative', value: 'Inoperative' },
                            { label: 'Operative', value: 'Operative' },
                          ]}
                          name="type"
                          value={values.type}
                          onChange={(val) => {
                            setFieldValue(`type`, val);
                          }}
                          error={errors.type && touched.type ? errors.type : null}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="serverOperation-save--btn--block">
                    <Button type="submit" className="serverOperation-save-btn save--btn" disabled={isSubmitting}>
                      Change Availability
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};

export default ChangeAvailabilityForm;
